import axios from 'axios';
import { config } from '../config';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  const headers: Record<string, string> = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  } else {
    headers['x-api-key'] = config.API_KEY || '';
  }

  return headers;
};

export interface TenantDashboardMessage {
  id: number;
  note: string;
  created_at: string;
}

export interface TenantMessageGroup {
  claim_id: number;
  claim_number: string;
  facility_id: string | null;
  status: string;
  status_label: string;
  tenant_name: string;
  messages: TenantDashboardMessage[];
}

export interface TenantMessagesDashboard {
  new_count: number;
  groups: TenantMessageGroup[];
}

export const getTenantMessagesDashboard = async (): Promise<TenantMessagesDashboard> => {
  const response = await axios.get(`${config.API_URL}/tenant-messages`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const ackTenantMessagesForClaim = async (
  claimId: string | number
): Promise<{ acknowledged: number }> => {
  const response = await axios.post(
    `${config.API_URL}/claims/${claimId}/tenant-messages/ack`,
    {},
    { headers: getAuthHeaders() }
  );
  return response.data;
};
